var map = {
	"./assets/img/Aveda.png": "1a29",
	"./assets/img/BBC.png": "a657",
	"./assets/img/BB_Logotype_SingleLine_Black_CMYK.png": "a425",
	"./assets/img/CCS.png": "9782",
	"./assets/img/CCS_BAK.png": "58c9",
	"./assets/img/CLINIQUE.png": "f9a6",
	"./assets/img/ELCCS_Logo.png": "0d48",
	"./assets/img/Group65.png": "f398",
	"./assets/img/Jo-Malone-London_Brand-Evo_Logo_Black.png": "a349",
	"./assets/img/LL-old.png": "69db",
	"./assets/img/LL.png": "3658",
	"./assets/img/La_Mer_Logo_Green.png": "b5e4",
	"./assets/img/La_Mer_Logo_White.png": "e4fa",
	"./assets/img/MAC.png": "1d4d",
	"./assets/img/TF.png": "bad4",
	"./assets/img/TH-areacode.png": "95d6",
	"./assets/img/TO.png": "8155",
	"./assets/img/VN_BBC.png": "fca9",
	"./assets/img/VN_BBC_footer.png": "f93e",
	"./assets/img/bobbibrown_logo_footer.png": "42c8",
	"./assets/img/bobbibrown_logo_header.png": "b9ef",
	"./assets/img/esteelauder_logo.png": "2186",
	"./assets/img/esteelauder_logo_footer.png": "97cb",
	"./assets/img/esteelauder_logo_header.png": "3f1e",
	"./assets/img/jomalone.png": "d9ab",
	"./assets/img/jomalone_logo_footer.png": "8af1",
	"./assets/img/jomalone_logo_header.png": "2dff",
	"./assets/img/jomalone_logo_header1.png": "e028",
	"./assets/img/lamer_logo_footer.png": "4f8f",
	"./assets/img/lamer_logo_header.png": "a0d9",
	"./assets/img/ls_logo_footer.png": "4720",
	"./assets/img/ls_logo_header.png": "6ab8",
	"./assets/img/or_logo_footer.png": "6b75",
	"./assets/img/or_logo_header.png": "f3af",
	"./assets/img/origins.png": "a712",
	"./assets/img/sg-areacode.png": "1a25",
	"./assets/img/th-en.png": "91ad",
	"./assets/img/th-th.png": "4954",
	"./assets/language/en": "4822",
	"./assets/language/en.js": "4822",
	"./assets/language/my": "9ef5",
	"./assets/language/my.js": "9ef5",
	"./assets/language/th": "55c8",
	"./assets/language/th.js": "55c8",
	"./assets/language/vn": "6341",
	"./assets/language/vn.js": "6341",
	"./assets/language/zh": "c8d0",
	"./assets/language/zh.js": "c8d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";